module.exports = __webpack_public_path__ + "44f175cca6a0875afbcb446050f25ef1.png";